import QuizTypes from '../constants/quiz';

const QUIZ_STATUS_PRIORITY = {
    EXPIRED: 1,
    PENDING: 2,
    INCOMPLETE: 3,
    PASSED: 4,
};

const getHighestPriorityStatus = histories => {
    if (!histories.length) return null;

    return histories.reduce(
        (highest, current) =>
            QUIZ_STATUS_PRIORITY[current.status] < QUIZ_STATUS_PRIORITY[highest.status] ? current : highest,
        histories[0]
    ).status;
};

const initialState = {
    selectedQuizId: null,
    histories: [],
    highestPriorityStatus: null,
    result: {},
    activeQuiz: {},
    showResult: false,
    isOpen: false,
    createQuiz: {
        theme: null,
        date: null,
        disabled: false,
        questions: [],
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case QuizTypes.SET_QUIZ_HISTORY:
            const highestPriorityStatus = getHighestPriorityStatus(action.payload);
            return {
                ...state,
                histories: action.payload,
                highestPriorityStatus,
            };
        case QuizTypes.SET_QUIZ_RESULT:
            return {
                ...state,
                result: action.payload,
                histories: state.histories.map(quiz =>
                    quiz.id === action.payload.id ? { ...quiz, status: action.payload.status } : quiz
                ),
                highestPriorityStatus: getHighestPriorityStatus(
                    state.histories.map(quiz =>
                        quiz.id === action.payload.id ? { ...quiz, status: action.payload.status } : quiz
                    )
                ),
            };
        case QuizTypes.SET_ACTIVE_QUIZ:
            return {
                ...state,
                activeQuiz: action.payload,
            };

        case QuizTypes.SET_SELECTED_QUIZ_ID:
            return {
                ...state,
                selectedQuizId: action.payload,
            };
        case QuizTypes.SET_RESET_RESULT:
            return {
                ...state,
                result: action.payload,
            };

        case QuizTypes.SET_SHOW_RESULT:
            return {
                ...state,
                showResult: action.payload,
            };
        case QuizTypes.SET_QUIZ_OPEN:
            return {
                ...state,
                isOpen: action.payload,
            };
        case QuizTypes.SET_CREATE_QUIZ:
            return {
                ...state,
                createQuiz: {
                    ...state.createQuiz,
                    ...action.payload,
                },
            };
        default:
            return state;
    }
};
